import { useTranslation } from 'react-i18next';
import { useFeatureFlag } from '@/hooks/useFeatureFlag';
import {
  Flex,
  type FlexProps,
  Heading,
  List,
  ListIcon,
  ListItem,
  Text,
  type TextProps,
} from '@/ui';

const Wave = (props: TextProps) => (
  <Text as="span" {...props}>
    🌊
  </Text>
);
const Calendar = (props: TextProps) => (
  <Text as="span" {...props}>
    📆
  </Text>
);
const Sparkles = (props: TextProps) => (
  <Text as="span" {...props}>
    ✨
  </Text>
);

export const Benefits = (props: FlexProps) => {
  const { t } = useTranslation('settingsModal', { keyPrefix: 'calendars' });
  const { value: outlookEnabled } = useFeatureFlag('outlookIntegrationEnabled');

  return (
    <Flex direction="column" gap="6" {...props}>
      <Heading as="h3" fontSize="lg" fontWeight="bold">
        {outlookEnabled
          ? t('benefits_heading_any_provider')
          : t('benefits_heading')}
      </Heading>

      <List display="flex" flexDir="column" fontWeight="medium" gap="3">
        <ListItem alignItems="center" display="flex">
          <ListIcon as={Wave} />
          <Text>Streamlined add-to-calendar</Text>
        </ListItem>
        <ListItem alignItems="center" display="flex">
          <ListIcon as={Calendar} />
          <Text>Send to specific calendars</Text>
        </ListItem>
        <ListItem alignItems="center" display="flex">
          <ListIcon as={Sparkles} />
          <Text>Connect multiple accounts</Text>
        </ListItem>
      </List>
    </Flex>
  );
};
